import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = ["innerHTML"];
import FormWrapper from './form-wrapper.vue';
import { UiTitle, UiText } from '@huntflow/ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'form-layout',
    props: {
        title: {},
        description: {},
        titleLevel: { default: 1 }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(FormWrapper, null, {
                header: _withCtx(() => [
                    _createVNode(_unref(UiTitle), {
                        level: __props.titleLevel,
                        weight: "medium"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", { innerHTML: __props.title }, null, 8, _hoisted_1)
                        ]),
                        _: 1
                    }, 8, ["level"]),
                    (__props.description)
                        ? (_openBlock(), _createBlock(_unref(UiText), { key: 0 }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.description), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
            }));
        };
    }
});
